import { Service } from "../../config/service";

class ConsultaCautelarService extends Service {

    constructor() {
        super("cautelar")
    }

    async validate(params, config = {}) {
        try {
            const response = await this.http84.get(`${this.getResource().get}/validate?${params}`, { params: this.getParams(), ...config })
            return Promise.resolve(response)
        } catch (e) {
            this.setError(e)
            return Promise.reject(this.getError())
        }
    }

    async export(params, config = {}) {
        try {
            const response = await this.http84.get(`${this.getResource().get}/export?${params}`, { params: this.getParams(), ...config })
            return Promise.resolve(response)
        } catch (e) {
            this.setError(e)
            return Promise.reject(this.getError())
        }
    }

}

export default ConsultaCautelarService
